<template>
	<div class="wrapper" :class="'wrapper' + num">
		<Menuitem :key="index" v-for="(item, index) in router" :num="num">
		<!-- <div class="item-title" v-if="!item.children" @click="handleClick(item.catalogName)">{{item.catalogName}}</div> -->
		<template>
			<span @click="tabIdx(index)">{{item.catalogName}}</span>
			<Menu :router="router[indexs].children" :num="num+1"></Menu>
		</template>
		</Menuitem>
	</div>
</template>
<script>
	import Menuitem from "./Menuitem";
	import bus from '../../../assets/js/bus'
	export default {
		name: "Menu",
		// props: ["router"], // Menu 组件接受一个 router 作为菜单数据
		components: {
			Menuitem
		},
		data() {
			return {
				indexs: 0
			};
		},
		props: {
			num: {
				type: Number
			},
			router: {
				type: [Array, Object]
			}
		},
		methods: {
			handleClick(i) {
				bus.$emit('datas', i)
			},
			tabIdx(index) {
				this.indexs = index
			}
		},
		mounted() {
			console.log(this.router)
		}
	};
</script>
<style scoped>
	.wrapper {
		cursor: pointer;
		/* display: flex;
		flex-wrap: wrap; */
	}

	.item-title {
		font-size: 16px;
	}

	.wrapper1 {
		/* display: -webkit-box; */
	}

	.circle {
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #0090FF;
		border-radius: 50%;
		margin-bottom: 5px;
		margin-right: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/assembly/menu/Menu.vue